import dayjs from 'dayjs';

export const parseBackendDate = (date: string): Date => dayjs(date + 'Z').toDate();

export const currentDate = (): Date => dayjs().toDate();

export const toBackendDate = (date: Date): string => dayjs(date).format('YYYY-MM-DD');
